import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {App} from "./App";
import Keycloak from "keycloak-js";

const keycloak = Keycloak("./resources/keycloak.json");

keycloak.init({onLoad: "login-required"}).then((authenticated) => {
    if (authenticated) {
        ReactDOM.render(
            <React.StrictMode>
                <App keycloak={keycloak}/>
            </React.StrictMode>,
            document.getElementById('root')
        );
    }
});
